import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateGisSettingsRequest,
  UpdateField,
  FetchGisSettingsRequest,
} from './gis-settings.actions'
import { getFormsState } from '../forms/forms.selectors'
import FormTrait from 'src/app/traits/form.trait'
import { getGisSettingsState } from './gis-settings.selectors'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { select, Store } from '@ngrx/store'
import { Map } from 'immutable'

@Component({
  selector: 'app-gis-settings',
  templateUrl: './gis-settings.component.html',
  styleUrls: ['./gis-settings.component.css'],
})
export class GisSettingsComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public forms: []
  private state$: Subscription
  private formsState$: Subscription
  public isLoading: boolean

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.state$ = this.store
      .pipe(select(getGisSettingsState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.formsState$ = this.store
      .pipe(select(getFormsState))
      .subscribe((state) => {
        this.forms = state.get('data').toJS()
      })

    this.store.dispatch(new FetchGisSettingsRequest())
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.formsState$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'data'),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        '',
      ),
    )
  }

  public checkboxChange(e: any, name?: string): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, e.target.checked, 'data'),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      // GIS_POINT_LAYER: 'required',
      // GIS_BUILDING_LAYER: 'required',
      GIS_GEOSERVER_URL: 'required',
      GIS_MAP_EXTENT: 'required',
      GIS_GEOSERVER_WORKSPACE: 'required',
      GIS_BASE_LAYER: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({
      GIS_GEOSERVER_URL: 'gis server url',
      GIS_GEOSERVER_WORKSPACE: 'gis workspace',
      GIS_MAP_EXTENT: 'gis extent',
      GIS_BASE_LAYER: 'gis base layer',
      // GIS_POINT_LAYER: 'gis point layer',
      // GIS_BUILDING_LAYER: 'gis building layer',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new UpdateGisSettingsRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, ''),
      )
    }
  }
}
